import { registerTour } from "../tourRegistry";

function getSteps() {
  const totalSteps = 4;
  const stepCounter = (n) => `Step ${n} of ${totalSteps}`;

  return [
    {
      id: 'ds-overview',
      title: `Donation Statements <span class="t3-shepherd-step-count">${stepCounter(1)}</span>`,
      text: 'Generate year-end donation statements for your donors. This report summarizes each donor\'s total contributions by fund — ready for tax receipts.',
      attachTo: { element: '[data-tour="ds-page"]', on: 'bottom' },
      buttons: [
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'ds-year',
      title: `Year Selector <span class="t3-shepherd-step-count">${stepCounter(2)}</span>`,
      text: 'Select the reporting year. The report shows all donations recorded during that calendar year, grouped by donor.',
      attachTo: { element: '[data-tour="ds-year-selector"]', on: 'bottom' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'ds-donor-table',
      title: `Donor Summary <span class="t3-shepherd-step-count">${stepCounter(3)}</span>`,
      text: 'The summary table shows every donor and their total contributions. Merged donors are automatically combined — if a donor was entered multiple times and later merged, all their donations roll up into one row.',
      attachTo: { element: '[data-tour="ds-donor-table"]', on: 'top' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'ds-export',
      title: `Export Statements <span class="t3-shepherd-step-count">${stepCounter(4)}</span>`,
      text: 'Export the full report as Excel, or generate individual PDF statements per donor for mailing. Individual PDFs include the donor\'s name, address, and a detailed breakdown of each contribution.',
      attachTo: { element: '[data-tour="ds-export"]', on: 'bottom' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Done',
          classes: 't3-shepherd-next-btn',
          action() { this.complete(); },
        },
      ],
    },
  ];
}

registerTour({
  id: 'donationStatements',
  pathPattern: '/reports/donations',
  getSteps,
  label: 'Donation Statements Tour',
});
